<template>
  <v-fade-transition>
    <wgu-module-card v-bind="$attrs" :moduleName="moduleName" :icon="icon" class="card" width=50% height=70%>

      <v-card-text class="heightRest text-lg-body-1 text-body-2" style="font-family: 'Open Sans';">
        <div>
          <h1>Rechtliche Hinweise (Disclaimer)</h1>
          <p>
            Bitte beachten Sie die wichtigen rechtlichen Hinweise zu den Inhalten und zur Verfügbarkeit dieser Website,&nbsp;
            zum Urheberrecht und zu externen Links.
          </p>

          <h2>Inhalte dieser Website</h2>
          <p>
            Die Inhalte dieses Webauftritts werden mit größtmöglicher Sorgfalt erstellt.&nbsp;
            Die StEB Köln übernehmen jedoch keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten Inhalte.
          </p>

          <h2>Technische Umsetzung</h2>
          <p>
            geomer GmbH, Heidelberg
          </p>

          <h2>Datenquellen</h2>
          <p>
            Abwasserwärme: StEB Köln
          </p>

          <h2>Bildnachweise</h2>
          <p>
            StEB Köln
          </p>
          <h2>Verfügbarkeit der Website</h2>
          <p>
            Die StEB Köln werden sich bemühen, den Dienst möglichst unterbrechungsfrei zum Abruf anzubieten.&nbsp;
            Auch bei aller Sorgfalt können aber Ausfallzeiten nicht ausgeschlossen werden.&nbsp;
            Wir behalten uns das Recht vor, das Angebot jederzeit zu ändern oder einzustellen.&nbsp;
            Für Unterbrechungen oder anderweitige Störungen können wir keine Gewähr übernehmen.
          </p>

          <h2>Hinweis zum Urheberrecht</h2>
          <p>
            Alle Inhalte und Strukturen dieser Website sind urheber- und leistungsschutzrechtlich geschützt.&nbsp;
            Die Veröffentlichung im World Wide Web oder in sonstigen Diensten des Internets bedeutet noch keine Einverständniserklärung&nbsp;
            für eine anderweitige Nutzung durch Dritte.&nbsp;
            Jede vom deutschen Urheberrecht nicht zugelassene Verwertung bedarf der vorherigen schriftlichen Zustimmung der StEB Köln.
          </p>

          <h2>Hinweis zur Verwendung externer Links</h2>
          <p>
            Die StEB Köln sind für die eigenen Inhalte, die sie zur Nutzung bereithalten, nach den allgemeinen Gesetzen&nbsp;
            verantwortlich. Von diesen eigenen Inhalten sind Querverweise (Links) auf die von anderen Anbietern bereitgehaltenen&nbsp;
            Inhalte zu unterscheiden.&nbsp;
            Durch den Querverweis halten die StEB Köln insofern fremde Inhalte zur Nutzung bereit, die als „Link“ gekennzeichnet sind.&nbsp;
          </p>
          <p>
            Bei Links handelt es sich stets um dynamische Verweisungen.&nbsp;
            Wir haben bei der erstmaligen Verknüpfung zwar den fremden Inhalt daraufhin überprüft, ob durch ihn eine mögliche&nbsp;
            zivilrechtliche oder strafrechtliche Verantwortlichkeit ausgelöst wird.&nbsp;
            Wir überprüfen aber die Inhalte, auf die wir in unserem Angebot verweisen, nicht ständig auf Veränderungen,&nbsp;
            die eine Verantwortlichkeit neu begründen könnten. Wenn wir feststellen&nbsp;
            oder von anderen darauf hingewiesen werden, dass ein konkretes Angebot, zu dem wir einen Link bereitgestellt haben,&nbsp;
            eine zivil- oder strafrechtliche Verantwortlichkeit auslöst, werden wir den Verweis auf dieses Angebot aufheben.&nbsp;
          </p>
          <p>&nbsp;</p>
      </div>
      </v-card-text>

    </wgu-module-card>
  </v-fade-transition>
</template>

<script>
// the module card is a the template for a typical Wegue module
import ModuleCard from '../../../src/components/modulecore/ModuleCard';

export default {
  name: 'wgu-rechtlichehinweise',
  // make sure to register the 'Mapable' mixin
  components: {
    'wgu-module-card': ModuleCard
  },
  created () {
  },
  props: {
    icon: { type: String, required: false, default: 'star' }
  },
  mounted () {
    // console.log(this.$parent.$el.offsetHeight);
  },
  // here we define variables that are used in the HTML above
  data () {
    return {
      moduleName: 'wgu-rechtlichehinweise'
    };
  },
  methods: {
    /**
     * This function is called once the map is bound to the application
     */
  }
};
</script>

<!-- Here we do the styling of our module -->
<style scoped>

.card {
  overflow: auto;
  left: 60% !important;
  right: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%);  /* zentriert Fenster, bei kleinen Bildschirmen dann*/
  /*
  height: 90%;
  width: 90%;
  */
  max-width: 90%;
  max-height: 90%;
  min-width: 250px;
  min-height: 250px;
  z-index: 55 !important;

}

.v-card > :last-child {
  overflow: auto;
  height: calc(100% - 70px);
}

h1 {
  font-size: 1.5em;
  line-height: 2rem;
  margin-bottom: 0.2em;
  color: #00508c;
}

h2 {
  font-size: 1.2em;
  margin-top: 20px;
  margin-bottom: 6px;
  color: #00508c;
}

h3 {
  font-size: 1.1em;
  margin-bottom: 0.2em;
  color: #00508c;
}

p {
  font-size: 1em;
  line-height: 1.5rem;
}

</style>
